var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWaves)?_c('div',[_c('v-img',{staticClass:"top",attrs:{"src":_vm.topImg,"eager":""}}),_c('v-img',{staticClass:"bottom",attrs:{"src":require('@/assets/img/background_bottom.png'),"eager":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }